import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { withTranslation } from '../../../common';

import MasterDataForm from './MasterDataForm';

import './_style.css';

import {
  changeMasterDataSelectors,
  changeMasterDataOperations
} from '../../../../state/changeMasterData';

import { editResourceSelectors } from '../../../../state/editResource';
import { resourcesSubTypesSelectors } from '../../../../state/resourcesSubTypes';

class MasterDataDetail extends Component {
  UNSAFE_componentWillMount() {
    const { initializeDetail, changeRequest } = this.props;
    if (changeRequest && changeRequest.resource) {
      initializeDetail(changeRequest);
    }
  }

  render() {
    const { changeRequest } = this.props;
    const { readOnly, status } = changeRequest;
    const isReadonly = readOnly || status === 'Approved' || status === 'Rejected';

    return (
      <div className="MasterDataForm">
        <MasterDataForm {...this.props} readOnly={isReadonly} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  resource: editResourceSelectors.getResource(state),
  floor: changeMasterDataSelectors.getFloor(state),
  sector: changeMasterDataSelectors.getSector(state),
  resourceSubType: changeMasterDataSelectors.getResourceSubType(state),
  resourcesSubTypes: resourcesSubTypesSelectors.getAll(state),
  capacity: changeMasterDataSelectors.getCapacity(state),
  roomEquipment: changeMasterDataSelectors.getRoomEquipment(state),
  roomEquipmentOptions: changeMasterDataSelectors.getRoomEquipmentOptions(state),
  daylight: changeMasterDataSelectors.getDaylight(state),
  confidentialMeetings: changeMasterDataSelectors.getConfidentialMeetings(state),
  notes: changeMasterDataSelectors.getNotes(state),
  contact: changeMasterDataSelectors.getContact(state),
  reason: changeMasterDataSelectors.getReason(state),
  contactSuggestions: changeMasterDataSelectors.getContactSuggestions(state),
  isContactLoading: changeMasterDataSelectors.isContactLoading(state),
  hasChanges: changeMasterDataSelectors.hasChanges(state),
  isValid: changeMasterDataSelectors.isValid(state)
});

const mapDispatchToProps = dispatch => ({
  submit: () => dispatch(changeMasterDataOperations.submit()),
  updateFormValue: (field, value) => dispatch(changeMasterDataOperations.updateFormValue(field, value)),
  loadContactSuggestions: term => dispatch(changeMasterDataOperations.loadContactSuggestions(term)),
  initializeDetail: changeRequest => {
    dispatch(changeMasterDataOperations.initializeDetail(changeRequest));
  }
});

MasterDataDetail.propTypes = {
  hasChanges: PropTypes.bool.isRequired,
  initializeDetail: PropTypes.func.isRequired,
  changeRequest: PropTypes.shape().isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired
  }).isRequired,
  translate: PropTypes.func.isRequired
};

const MasterDataDetailComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(MasterDataDetail);
export default withTranslation(withRouter(MasterDataDetailComponent));
